sc-order-submit {
  display:block;
  width: auto;
}
